export var RuleBuilderTypes = /* @__PURE__ */ ((RuleBuilderTypes2) => {
  RuleBuilderTypes2["Boolean"] = "java.lang.Boolean";
  RuleBuilderTypes2["Message"] = "org.graylog2.plugin.Message";
  RuleBuilderTypes2["Number"] = "java.lang.Long";
  RuleBuilderTypes2["Object"] = "java.lang.Object";
  RuleBuilderTypes2["String"] = "java.lang.String";
  RuleBuilderTypes2["Void"] = "java.lang.Void";
  RuleBuilderTypes2["DateTime"] = "org.joda.time.DateTime";
  RuleBuilderTypes2["DateTimeZone"] = "org.joda.time.DateTimeZone";
  RuleBuilderTypes2["DateTimeFormatter"] = "org.joda.time.format.DateTimeFormatter";
  return RuleBuilderTypes2;
})(RuleBuilderTypes || {});
export const RULE_BUILDER_TYPES_WITH_OUTPUT = [
  "java.lang.Boolean" /* Boolean */,
  "java.lang.Long" /* Number */,
  "java.lang.String" /* String */,
  "java.lang.Object" /* Object */,
  "org.graylog2.plugin.Message" /* Message */,
  "org.joda.time.DateTime" /* DateTime */
];
